module.exports = __webpack_public_path__ + "img/bg-hair2.0cf4ea38.png";